const isSize = name => /größe|groesse|grösse|\bsize\b/i.test(name);

export function availabilityAlternatives(data, selection) {
  const product = data.product;
  if (selection.length !== product.options.length || selection.some(value => !value)) return [];
  const requested = product.variants.find(variant => variant.options.every((value,index) => value === selection[index]));
  if (!requested || requested.available) return [];
  const sizeIndexes = product.options.map((name,index) => isSize(name) ? index : -1).filter(index => index >= 0);
  if (!sizeIndexes.length) return [];
  const results = [];
  if (sizeIndexes.length < product.options.length) {
    for (const variant of product.variants) {
      if (variant.available && sizeIndexes.every(index => variant.options[index] === selection[index])) {
        results.push({ product, variant, kind:'same_sizes' });
      }
    }
  }
  if (product.options.length === 1 && sizeIndexes.length === 1) {
    for (const sibling of data.siblings || []) {
      if (sibling.options.length !== 1 || !isSize(sibling.options[0])) continue;
      const variant = sibling.variants.find(item => item.available && item.options[0] === selection[0]);
      if (variant) results.push({ product:sibling, variant, kind:'same_sizes' });
    }
  }
  if (product.handle === 'spati-sweat-suit' && selection[1] === 'XL' && data.component) {
    const variant = data.component.variants.find(item => item.available && item.options.length === 1 && item.options[0] === selection[0]);
    if (variant) results.push({ product:data.component, variant, kind:'sweater_only' });
  }
  return results.slice(0,3);
}

if (typeof document !== 'undefined') {
  const initialized = new WeakSet();
  function init() {
    for (const root of document.querySelectorAll('[data-availability-alternatives]')) {
      if (initialized.has(root)) continue;
      const productForm = document.querySelector(`form[data-js-product-form][data-section-id="${CSS.escape(root.dataset.sectionId)}"]`);
      const purchaseArea = productForm?.querySelector('.product-add-to-cart');
      if (!purchaseArea) continue;
      initialized.add(root);
      const data = JSON.parse(root.querySelector('[data-availability-data]').textContent);
      const list = root.querySelector('[data-availability-list]');
      const heading = root.querySelector('[data-availability-heading]');
      // Keep the restock request (eisdieler-back-in-stock.js) directly under the button.
      const restock = purchaseArea.nextElementSibling?.matches('[data-eisdieler-bis]') ? purchaseArea.nextElementSibling : purchaseArea;
      restock.insertAdjacentElement('afterend', root);
      const update = () => {
        const fieldsets = [...productForm.querySelectorAll('fieldset')].filter(fieldset => fieldset.querySelector('input[name^="option"]'));
        let selection = fieldsets.map(fieldset => fieldset.querySelector('input[type="radio"]:checked')?.value);
        if (!selection.length) {
          const id = productForm.querySelector('[name="id"]')?.value;
          selection = data.product.variants.find(variant => String(variant.id) === String(id))?.options || [];
        }
        const alternatives = availabilityAlternatives(data,selection);
        list.replaceChildren();
        root.hidden = !alternatives.length;
        heading.textContent = root.dataset.heading.replace('{selection}', selection.join(' / '));
        for (const item of alternatives) {
          const link = document.createElement('a');
          link.href = `${item.product.url}?variant=${item.variant.id}`;
          const image = document.createElement('img');
          image.src = item.product.image;
          image.alt = '';
          image.width = 56;
          image.height = 70;
          image.loading = 'lazy';
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = item.product.title;
          const detail = document.createElement('span');
          detail.textContent = `${item.variant.title} · ${item.variant.price}`;
          const note = document.createElement('small');
          note.textContent = item.kind === 'sweater_only' ? root.dataset.sweaterOnly : root.dataset.sameSizes;
          copy.append(title,detail,note);
          link.append(image,copy);
          const li = document.createElement('li');
          li.append(link);
          list.append(li);
        }
      };
      productForm.addEventListener('change',update);
      window.themeCore?.EventBus.listen(`pdp:section-${root.dataset.sectionId}:change-variant`,update);
      update();
    }
  }
  if (window.themeCore?.loaded) init();
  else document.addEventListener('theme:all:loaded',init,{once:true});
  document.addEventListener('shopify:section:load',init);
}
